import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useMain } from "./Main";


export const useSettings = () => {
    const { state, setData } = useMain();
    const changeAlertChat = () => {
        setData('alertChat', !state.alertChat);
    }
    return { state, changeAlertChat }
}


export const useSupport = () => {

    const { setForm, Request, loading } = useMain();
    const { send: load } = loading
    const send = () => {
        Request('ticketSended', '/');
    }

    return { setForm, send, load }
}

